module.exports = __webpack_public_path__ + "media/images/icons/twitter_share-79966475392e5bc6672d7fb4609cc627.svg";